import { lazy, Suspense } from 'react';
import type { RoleModule } from '../types';

/**
 * The doctor surface's routes and door overrides. See ../types.ts.
 * Every route path here must start with `/doctor/`.
 */
const DoctorMessagesPage = lazy(() => import('@/pages/doctor/messages/DoctorMessagesPage'));
const ManagerDayPage = lazy(() => import('./ManagerDayPage'));
const ManagerDayAlerts = lazy(() => import('./ManagerDayPage').then((m) => ({ default: m.ManagerDayAlerts })));

const doctor: RoleModule = {
  routes: [
    {
      /* The other inbox — Today's "N patient messages" chip and the Results
         screen's primary both land here. */
      path: '/doctor/messages',
      element: (
        <Suspense fallback={null}>
          <DoctorMessagesPage />
        </Suspense>
      ),
    },
    {
      /* THE DUAL-ROLE DAY (g_mgrday, f16) — the doctor's day with the clinic
         manager's business view under it. It is the manager hat's own "Today",
         not the doctor's: /today is the doctor's day on four other boards, and
         f16 replaces its lower half and its second header icon. The hat's door
         still points at /dashboard, which is a shared file — the one-line
         `doorRoutes` diff is in the lane report. */
      path: '/doctor/day',
      element: (
        <Suspense fallback={null}>
          <ManagerDayPage />
        </Suspense>
      ),
    },
    {
      path: '/doctor/day/alerts',
      element: (
        <Suspense fallback={null}>
          <ManagerDayAlerts />
        </Suspense>
      ),
    },
  ],
  doorRoutes: {},
};

export default doctor;
